import React, { useEffect, useRef, useState } from "react";

export default function CustomCursor() {
  const [enabled, setEnabled] = useState(false);
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    setEnabled(true);
    document.documentElement.classList.add("custom-cursor-on");

    const pos = { x: -100, y: -100 };
    const ring = { x: -100, y: -100 };
    let hovering = false;
    let hidden = false;
    let pressed = false;
    let raf = 0;

    const onMove = (e) => {
      pos.x = e.clientX;
      pos.y = e.clientY;
      const t = e.target;
      const interactive = t.closest && t.closest("a, button, [role='button'], label, select, .cursor-hover");
      const textField = t.closest && t.closest("input, textarea, [contenteditable='true'], .ql-editor");
      hovering = !!interactive;
      hidden = !!textField;
    };
    const onDown = () => { pressed = true; };
    const onUp = () => { pressed = false; };
    const onLeave = () => { hidden = true; };
    const onEnter = () => { hidden = false; };

    const loop = () => {
      ring.x += (pos.x - ring.x) * 0.18;
      ring.y += (pos.y - ring.y) * 0.18;
      const dot = dotRef.current;
      const rg = ringRef.current;
      if (dot && rg) {
        const dotScale = pressed ? 0.6 : 1;
        const ringScale = pressed ? 0.9 : hovering ? 1.7 : 1;
        dot.style.opacity = hidden ? "0" : "1";
        rg.style.opacity = hidden ? "0" : "1";
        dot.style.transform = `translate(${pos.x}px, ${pos.y}px) translate(-50%, -50%) scale(${dotScale})`;
        rg.style.transform = `translate(${ring.x}px, ${ring.y}px) translate(-50%, -50%) scale(${ringScale})`;
        rg.style.borderColor = hovering ? "rgba(255, 138, 0, 0.9)" : "rgba(255, 255, 255, 0.35)";
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("mousedown", onDown);
    window.addEventListener("mouseup", onUp);
    document.documentElement.addEventListener("mouseleave", onLeave);
    document.documentElement.addEventListener("mouseenter", onEnter);

    return () => {
      cancelAnimationFrame(raf);
      document.documentElement.classList.remove("custom-cursor-on");
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mousedown", onDown);
      window.removeEventListener("mouseup", onUp);
      document.documentElement.removeEventListener("mouseleave", onLeave);
      document.documentElement.removeEventListener("mouseenter", onEnter);
    };
  }, []);

  if (!enabled) return null;
  return (
    <>
      <div ref={ringRef} className="cursor-ring" data-testid="custom-cursor-ring" aria-hidden="true" />
      <div ref={dotRef} className="cursor-dot" data-testid="custom-cursor-dot" aria-hidden="true" />
    </>
  );
}
